import api from "./api";
import CookieService from './cookie'
import TokenService from "./token";

class AuthService {
  login({email, password}) {
    return api
      .post("/login_check", {
        email,
        password
      })
      .then((response) => {
        if (response.data.token) {
          TokenService.setAccessToken(response.data);
        }

        return TokenService.getTokenData();
      })
      .catch(reason => {
        CookieService.removeAllCookies(true, TokenService.getTokenName())

        return Promise.reject(reason)
      });
  }

  logout() {
    return api
      .get("/logout")
      .then((response) => {
        CookieService.removeAllCookies(true, TokenService.getTokenName())

        return response;
      });
  }

  profile() {
    return api
      .get("/user-profile")
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch(reason => {
        return Promise.reject(reason)
      });
  }

  refresh() {
    const sentRefreshToken = TokenService.getLocalRefreshToken()

    return api
      .post("/token/refresh", {
        'refresh_token': sentRefreshToken
      })
      .then((response) => {
        if (response.data.token) {
          TokenService.updateLocalAccessToken(response.data);
        }

        return response;
      })
      .catch(reason => {
        // Refresh tokens are single-use and the session cookie is shared across tabs/apps, so a
        // concurrent refresh elsewhere can win the race and rotate the token we just sent. If the
        // cookie now holds a different refresh token, that session is valid — don't wipe it;
        // resolve so the caller retries with the cookie's current token.
        let currentRefreshToken = null

        try {
          currentRefreshToken = TokenService.getLocalRefreshToken()
        } catch {
          // malformed cookie — treat as no session and clear it below
        }

        if (currentRefreshToken && currentRefreshToken !== sentRefreshToken) {
          return {data: TokenService.getAccessToken()}
        }

        CookieService.removeAuthCookies(TokenService.getTokenName())

        return Promise.reject(reason)
      });
  }

  register(customer) {
    return api.post("/customers/register", customer);
  }

  update(customer) {
    return api.put("/customers/" + customer.id, customer);
  }

  loadAuthorization(values) {
    return api.get('/users/' + values.uid + '/authorization?productIds=' + values.productIds);
  }

  loadUserData(customerId) {
    return api.get('/users/' + customerId + '?groups[]=address:read');
  }

  startOAuth(provider) {
    return api
        .get('/oauth/' +provider + '/start')
        .then((response) => {
          window.location.href = response.data.auth_url;
        })
        .catch(reason => {
          CookieService.removeAuthCookies(TokenService.getTokenName())

          return Promise.reject(reason)
        });
  }

  handleOAuthCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const refresh_token = urlParams.get('refresh_token');

    if (token && refresh_token) {
      const data = {
        token: token,
        refresh_token: refresh_token
      };
      TokenService.setAccessToken(data);
    }
  }
}

export default new AuthService();
